// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CgDt","icon":"styles_icon__pJvbo"};